import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ShopCatalog from './pages/Catalog/ShopCatalog'
import ShopDetails from './pages/Details/ShopDetails'

function Shop() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<ShopCatalog />} />
        <Route path="/:slug" element={<ShopDetails />} />
      </Routes>
    </>
  )
}

export default Shop
